import Vue from 'vue'
import Router from 'vue-router'
import mainView from '@/components/mainView'
import setWeight from '@/components/setWeight'
import fullHistory from '@/components/fullHistory'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'mainView',
      component: mainView
    },
    {
      path: '/setWeight',
      name: 'setWeight',
      component: setWeight,
      // props: true
    },
    {
      path: '/history',
      name: 'fullHistory',
      component: fullHistory,
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js